import React from 'react';
import { Button, Card, Modal, Table } from 'antd';

const ErrorSPStockSupplier = ({ failedModal, closeModal, failedData, loading, setPage, setPagesize, setMainSort }) => {
  const columns = [
    {
      title: 'Before Item',
      dataIndex: 'id_qad',
    },
    {
      title: 'Pesan',
      dataIndex: 'reason',
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setPagesize(pagination.pageSize);
    setMainSort({
      sort: sorter.field,
      order: sorter.order,
    });
  };

  return (
    <Modal title="Detail Error Adjust Stock Inventory" visible={failedModal} width={1200} footer={null} onCancel={closeModal}>
      <Card className="body-data">
        <div name="control-hooks">
          <Table columns={columns} dataSource={failedData} rowKey={(data) => data._id} onChange={handleTableChange} loading={loading} />
          <div>
            <Button onClick={closeModal}>Tutup</Button>
          </div>
        </div>
      </Card>
    </Modal>
  );
};

export default ErrorSPStockSupplier;
